import { CommonResponseModel } from "@needle-management/shared-models";

export class StyleCreateRequest {
    style: StyleModel[];
    userName : string;

    constructor(
        style: StyleModel[],
         userName : string

    ) {
        this.style = style;
        this.userName = userName;
    }
}


export class StyleModel {
    id?: number;
    style: string;
    isActive?: boolean;

    constructor(
        style: string,
        id?: number,
        isActive?: boolean,

    ) {
        this.id = id;
        this.style = style;
        this.isActive = isActive;
    }
}


export class StyleResponse extends CommonResponseModel {
    data?: StyleModel[];

    constructor(status: boolean, errorCode: number, internalMessage: string, data?: StyleModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}